import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-tma-android',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './tma-android.component.html',
  styleUrl: './tma-android.component.css'
})
export class TmaAndroidComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('TMA Android : Maintenance, Correction de Crashs & Optimisation — Agréée CII');
    this.metaService.updateTag({
      name: 'description',
      content: 'Confiez la maintenance de votre application Android à des experts Kotlin & Java. Élimination des crashs, optimisation des performances et conformité Play Store. Éligible au CII.'
    });
  }
}
